import { useEffect } from 'react';
import { SiteFooter, SiteHeader } from './SiteChrome';

export const Privacy = () => {
  useEffect(() => {
    document.title = 'Privacy Policy - Field Facts: Baseball';
  }, []);

  return (
    <div className="ff-page">
      <SiteHeader />
      <div className="ff-content ff-legal">
        <p className="ff-kicker">Legal</p>
        <h1>Privacy Policy</h1>
        <p className="effective-date">Effective July 13, 2026</p>

        <p>
          Field Facts: Baseball ("Field Facts", "we", "us") is operated by Aeso, LLC.
          This policy describes what information we collect through the Field Facts
          mobile app and website, and how we use it.
        </p>

        <h2>Information we collect</h2>
        <ul>
          <li><strong>Account information.</strong> If you create an account in the app, we collect your name, email address, and password. Browsing does not require an account.</li>
          <li><strong>Content you contribute.</strong> Field details, photos, ratings, and reviews you submit are stored with your account and shown publicly to other users alongside your display name.</li>
          <li><strong>Location.</strong> With your permission, the app uses your device location to find fields near you. The website may request your browser location for the same purpose. Location is used at the time of the request and is not stored as a location history.</li>
          <li><strong>Usage and diagnostics.</strong> We collect analytics about how the app and website are used, and crash/error reports, to keep the service working well.</li>
        </ul>

        <h2>How we use information</h2>
        <ul>
          <li>To operate the field directory: showing fields, photos, ratings, and reviews to the community.</li>
          <li>To find fields near you when you ask us to.</li>
          <li>To moderate content, respond to reports, and keep the community safe.</li>
          <li>To fix bugs and improve the product.</li>
        </ul>

        <h2>What we don't do</h2>
        <ul>
          <li>We do not sell your personal information.</li>
          <li>We do not share your email address publicly or with other users.</li>
          <li>We do not use your data for third-party advertising profiles.</li>
        </ul>

        <h2>Where your data lives</h2>
        <p>
          Data is stored in Google Firebase (Firestore, Cloud Storage, and Firebase
          Authentication), subject to Google's security practices. Analytics are
          provided by Google Analytics for Firebase.
        </p>

        <h2>Your choices</h2>
        <ul>
          <li>You can use the app and website without an account, in read-only mode.</li>
          <li>You can delete your review or photos from the app at any time.</li>
          <li>You can delete your account from the app menu ("Delete My Account"). Content you contributed to the community directory (field details, photos, reviews) remains part of the directory.</li>
          <li>You can decline location permissions; search still works by name, city, or zip code.</li>
        </ul>

        <h2>Children</h2>
        <p>
          Field Facts is not directed at children under 13, and we do not knowingly
          collect personal information from them. Accounts are intended for parents,
          coaches, and players of age.
        </p>

        <h2>Contact</h2>
        <p>
          Questions, data requests, or deletion help:{' '}
          <a href="mailto:support@fieldfactsbaseball.com">support@fieldfactsbaseball.com</a>.
        </p>

        <p>
          We may update this policy as the product evolves; material changes will be
          reflected by a new effective date on this page.
        </p>
      </div>
      <SiteFooter />
    </div>
  );
};
